import React from "react";
import styled from "styled-components";

// The left-hand template list shared by NarrativeTemplateManager and
// QuestionTemplateManager. Templates come in two scopes: 'default' (org-wide) and
// 'user' (the caller's own). Everyone sees both, so the rail always shows both groups
// and the manager decides what is editable. Creating a default template accepts
// SFQ_STUDY_EDIT or SFQ_ADMIN, while creating a user template requires SFQ_STUDY_EDIT.

const Rail = styled.div`
  width: 240px;
  flex-shrink: 0;
  border-right: 1px solid #dee2e6;
  padding: 4px 0 12px;
  align-self: stretch;
`;

const GroupLabel = styled.div`
  padding: 12px 14px 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
`;

const Item = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 7px 14px;
  border: none;
  border-left: 3px solid ${(p) => (p.$active ? "#0d6efd" : "transparent")};
  background: ${(p) => (p.$active ? "#e7f1ff" : "transparent")};
  color: ${(p) => (p.$active ? "#0d6efd" : "#495057")};
  font-size: 13px;
  cursor: pointer;
  &:hover { background: ${(p) => (p.$active ? "#e7f1ff" : "#f1f3f5")}; }
`;

// 템플릿 이름은 200자까지 들어와 좁은 레일을 그대로 뚫고 나간다. 두 줄까지만 보이고
// 나머지는 …로 접는다 — 공백 없이 긴 이름도 접히도록 overflow-wrap을 함께 건다.
// 잘린 이름은 title 툴팁으로 전체를 확인할 수 있다.
const ItemName = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
`;

const ItemMeta = styled.div`
  font-size: 11px;
  color: #adb5bd;
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Empty = styled.div`
  padding: 4px 14px 6px;
  font-size: 12px;
  color: #adb5bd;
`;

const AddBtn = styled.button`
  margin: 6px 14px 0;
  padding: 4px 10px;
  border: 1px dashed #6c757d;
  background: transparent;
  color: #6c757d;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  &:hover { border-color: #0d6efd; color: #0d6efd; }
`;

export default function TemplateListRail({
  templates,
  loading,
  selectedId,
  onSelect,
  onCreate,
  canCreateDefault,
  canCreateUser,
  showCount = false,
}) {
  const defaults = templates.filter((t) => t.scope === "default");
  const mine     = templates.filter((t) => t.scope === "user");

  function renderItems(list) {
    if (!list.length) return <Empty>없음</Empty>;
    return list.map((t) => (
      <Item key={t.id} $active={t.id === selectedId} onClick={() => onSelect(t.id)} title={t.name}>
        <ItemName>{t.name}</ItemName>
        {showCount && <ItemMeta>{t.questionCount}개 문항</ItemMeta>}
      </Item>
    ));
  }

  return (
    <Rail>
      <GroupLabel>기본 템플릿</GroupLabel>
      {loading && !templates.length ? <Empty>불러오는 중…</Empty> : renderItems(defaults)}
      {canCreateDefault && <AddBtn onClick={() => onCreate("default")}>+ 새 기본 템플릿</AddBtn>}

      {/* Hide the whole group for callers who can neither create user templates nor
          own any — but keep it if they still hold ones authored before losing the
          permission. */}
      {(canCreateUser || mine.length > 0) && (
        <>
          <GroupLabel>내 템플릿</GroupLabel>
          {loading && !templates.length ? <Empty>불러오는 중…</Empty> : renderItems(mine)}
          {canCreateUser && <AddBtn onClick={() => onCreate("user")}>+ 새 템플릿</AddBtn>}
        </>
      )}
    </Rail>
  );
}
